import {
  ADHESION_DOCUMENT_TYPES,
  SINISTER_DOCUMENT_TYPES,
} from 'constants/globalConstants';
import { get, isFunction } from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import {
  downloadPdfFail,
  downloadPdfSuccess,
  getRefundAMCDetailsFailed,
  getRefundsAMCFailed,
  getSinistreDetailsFailed,
  getSinistresFailed,
  setRefundAMCDetails,
  setRefundsAMC,
  setSinistreDetails,
  setSinistres,
} from 'store/sinistre/actions';
import {
  downloadAccordApi,
  downloadCA,
  downloadConvocationApi,
  downloadDecompte,
  downloadInfoComplementaryApi,
  getDetailRefundAMCApi,
  getRefundsAMCApi,
  getSinistreApi,
  getSinistreDetailsApi,
} from 'store/sinistre/api';
import {
  DOWNLOAD_PDF_ACTIONS,
  GET_REFUNDS_AMC,
  GET_REFUND_AMC_DETAILS,
  GET_SINISTRES,
  GET_SINISTRE_DETAILS,
} from 'store/sinistre/constants';
import { SetRefundAMCDetailsType, setSinistreDetailsType } from './types';

interface ResponseGenerator {
  data?: any;
}
export function* getSinistres() {
  try {
    const language: string = yield select(getLocaleSelector);
    const { data: response } = yield call(getSinistreApi, {
      language,
    });
    if (response.success) {
      yield put(setSinistres(response.data));
    } else {
      yield put(getSinistresFailed());
    }
  } catch {
    yield put(getSinistresFailed());
  }
}
export function* watchGetSinistres() {
  yield takeLatest(GET_SINISTRES, getSinistres);
}

export function* getSinistreDetails(payload: any) {
  try {
    const language: string = yield select(getLocaleSelector);
    const { data: response } = yield call(getSinistreDetailsApi, {
      language,
      claimNumber: payload.claimNumber,
    });
    if (response.success) {
      yield put(setSinistreDetails(response.data.timeline));
    } else {
      yield put(getSinistreDetailsFailed());
    }
  } catch (err: any) {
    if (err.message === 'Request failed with status code 404') {
      const result: setSinistreDetailsType = yield put(setSinistreDetails([]));
      return result;
    }

    yield put(getSinistreDetailsFailed());
  }
}

export function* watchGetSinistreDetails() {
  yield takeLatest(GET_SINISTRE_DETAILS, getSinistreDetails);
}

export function* getRefundsAMCSaga({ payload }: any = {}) {
  try {
    const response: ResponseGenerator = yield call(getRefundsAMCApi, payload);
    const formatedResponse = get(response, 'data', {});
    if (formatedResponse.success) {
      const refunds = get(formatedResponse.data, 'items', {});
      const total = get(formatedResponse.data, 'total', 0);
      yield put(setRefundsAMC({ data: refunds, total: total }));
    } else {
      yield put(getRefundsAMCFailed('Error loading refunds'));
    }
  } catch (error) {
    yield put(getRefundsAMCFailed(error as any));
  }
}

export function* watchGetRefundsAMCSaga() {
  yield takeLatest(GET_REFUNDS_AMC, getRefundsAMCSaga);
}

export function* getRefundAmcDetails(payload: any) {
  try {
    const response: ResponseGenerator = yield call(
      getDetailRefundAMCApi,
      payload,
    );
    if (response.data.success) {
      yield put(setRefundAMCDetails(response.data));
    } else {
      yield put(getRefundAMCDetailsFailed(payload));
    }
  } catch (err: any) {
    if (err.message === 'Request failed with status code 404') {
      const result: SetRefundAMCDetailsType = yield put(
        setRefundAMCDetails({}),
      );
      return result;
    }

    yield put(getRefundAMCDetailsFailed(err));
  }
}

export function* watchGetRefundAMCDetails() {
  yield takeLatest(GET_REFUND_AMC_DETAILS, getRefundAmcDetails);
}

const getApiByType = {
  [SINISTER_DOCUMENT_TYPES.CV]: downloadConvocationApi,
  [SINISTER_DOCUMENT_TYPES.CI]: downloadInfoComplementaryApi,
  [SINISTER_DOCUMENT_TYPES.ACCORD]: downloadAccordApi,
  [ADHESION_DOCUMENT_TYPES.CA]: downloadCA,
  [SINISTER_DOCUMENT_TYPES.DECOMPTE]: downloadDecompte,
};

export function* downloadPdf({ payload, onSuccess, onError }: any) {
  try {
    const language: string = yield select(getLocaleSelector);
    const response: {
      data: {
        isSuccess: boolean;
        content: string;
        warningMessage: string;
      };
    } = yield call(getApiByType[payload.type], {
      language,
      ...payload,
    });

    if (response?.data?.isSuccess) {
      const {
        data: { content },
      } = response;
      yield put(downloadPdfSuccess(content));
      if (onSuccess && isFunction(onSuccess)) {
        onSuccess(content);
      }
    } else {
      const error = response?.data?.warningMessage;
      yield put(downloadPdfFail(error));
      if (onError && isFunction(onError)) {
        onError(error);
      }
    }
  } catch (_) {
    yield put(downloadPdfFail('internalServerError'));
    if (onError && isFunction(onError)) {
      onError('internalServerError');
    }
  }
}

export function* watchDownloadPdf() {
  yield takeLatest(DOWNLOAD_PDF_ACTIONS.START, downloadPdf);
}

export default [
  watchGetSinistres,
  watchGetSinistreDetails,
  watchGetRefundsAMCSaga,
  watchGetRefundAMCDetails,
  watchDownloadPdf,
];
